import { useOrganizationStore } from "@/stores/organizationStore";

/**
 * The current label's reporting currency: the currency the ledger books in and
 * that amounts are shown in unless a record carries its own. Falls back to
 * "USD" before a label is loaded.
 */
export function useLabelCurrency(): string {
  return useOrganizationStore((s) => s.currentLabel?.currency ?? "USD");
}
